import dayjs from "dayjs";

export const getUserAccessiblePages = (userDetails) => {
  if (userDetails && userDetails.rolePrivilegeDetails) {
    const rolePrivilegeDetails = userDetails.rolePrivilegeDetails;
    const menuObj = {};
    rolePrivilegeDetails.forEach(function (details) {
      details.privilegeList.forEach(function (privilage) {
        const channels = privilage.channel;
        const pageElementsVal = privilage.pageElements
          ? privilage.pageElements[0]
          : [];
        privilage.pages?.forEach(function (page) {
          if (page) {
            if (menuObj[page]) {
              const addedValues = menuObj[page];
              if (channels) {
                menuObj[page] = [...addedValues, ...channels];
              } else if (pageElementsVal[page]) {
                menuObj[page] = [...addedValues, ...pageElementsVal[page]];
              }
            } else if (channels) {
              menuObj[page] = [...channels];
            } else if (pageElementsVal[page]) {
              menuObj[page] = [...pageElementsVal[page]];
            } else {
              menuObj[page] = [];
            }
          }
        });
      });
    }); 
    return menuObj;
  } else {
    return null;
  }
};

export const getFormattedDate = (dateStr) => {
  try {
    return dayjs(dateStr).format("DD/MM/YYYY");
  } catch (error) {
    return "NA";
  }
};

export const getFormattedDateWithTime = (dateStr) => {
  try {
    return dayjs(dateStr).format("DD/MM/YYYY HH:mm");
  } catch (error) {
    return "NA";
  }
};

export const convertToCamelCase = (string) => {
  if (!string) return "";

  const words = string
    .replace(/([A-Z])/g, " $1")
    .trim()
    .split(" ");
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const getDestinationName = (locationResponse, locationId) => {
  const destination = locationResponse.filter(
    (item) => item.locationId === locationId
  );
  return destination.length > 0 ? destination[0].locationName : "NA";
};
